import { RoleEnum } from '../shared/models/general/general-enum';

export type FlexyooNavLinks = FlexyooNavLinkExpandable | FlexyooNavLinkItem;

export type FlexyooNavLinkExpandable = {
  role: RoleEnum;
  translationsKey: string;
  icon: string;
  isCustomIcon?: boolean;
  children: FlexyooNavLinkItem[];
  isExpandable: true;
  isOpened: boolean;
};

export type FlexyooNavLinkItem = {
  role: RoleEnum;
  translationsKey: string;
  icon: string;
  link: string;
  isCustomIcon?: boolean;
  iconClass?: string;
  isExpandable: false;
  isDisabled?: boolean;
};

export const HR_CAFETERIA_LINKS: FlexyooNavLinkItem[] = [
  {
    role: RoleEnum.HR,
    link: '/hr/transactions-history',
    icon: 'list_alt',
    translationsKey: 'base-layout.transactions-history',
    isExpandable: false,
  },
  {
    role: RoleEnum.HR,
    link: '/hr/benefits',
    icon: 'redeem',
    translationsKey: 'base-layout.benefits',
    isExpandable: false,
  },
  {
    role: RoleEnum.HR,
    link: '/hr/voting-period',
    icon: 'fo-calendar',
    iconClass: 'menu-link-icon-small',
    isCustomIcon: true,
    translationsKey: 'base-layout.voting-period',
    isExpandable: false,
  },
  {
    role: RoleEnum.HR,
    link: '/hr/payroll-management',
    icon: 'euro_symbol',
    translationsKey: 'base-layout.payroll-management',
    isExpandable: false,
  },
];

export const HR_MB_LINKS: FlexyooNavLinkItem[] = [
  {
    role: RoleEnum.HR,
    link: '/hr/mbp/ownership-cost',
    icon: 'fo-tco',
    isCustomIcon: true,
    translationsKey: 'base-layout.ownership-cost',
    isExpandable: false,
  },
  {
    role: RoleEnum.HR,
    link: '/hr/mbp/budgets-management',
    icon: 'fo-budgets',
    isCustomIcon: true,
    translationsKey: 'base-layout.budgets-management',
    isExpandable: false,
  },
  {
    role: RoleEnum.HR,
    link: '/hr/mbp/transactions',
    icon: 'list_alt',
    translationsKey: 'base-layout.transactions-history',
    isExpandable: false,
  },
  {
    role: RoleEnum.HR,
    link: '/hr/mbp/benefits',
    icon: 'redeem',
    translationsKey: 'base-layout.benefits',
    isExpandable: false,
  },
  // {
  //   role: RoleEnum.HR,
  //   link: '/hr/mbp/payroll-management',
  //   icon: 'euro_symbol',
  //   translationsKey: 'base-layout.payroll-management',
  //   isExpandable: false,
  // },
];

export const ADMIN_LINKS: FlexyooNavLinks[] = [
  {
    role: RoleEnum.Admin,
    link: '/admin/parameters',
    icon: 'fo-settings',
    isCustomIcon: true,
    translationsKey: 'base-layout.parameters',
    isExpandable: false,
  },
  {
    role: RoleEnum.Admin,
    link: '/admin/opcos',
    icon: 'fo-opco',
    isCustomIcon: true,
    translationsKey: 'base-layout.opcos',
    isExpandable: false,
  },
  {
    role: RoleEnum.Admin,
    link: '/admin/users',
    icon: 'fo-person',
    isCustomIcon: true,
    translationsKey: 'base-layout.users',
    isExpandable: false,
  },
  {
    role: RoleEnum.Admin,
    link: '/admin/tools',
    icon: 'fo-tools',
    isCustomIcon: true,
    translationsKey: 'base-layout.tools',
    isExpandable: false,
  },
  {
    role: RoleEnum.Admin,
    link: '/admin/statistics',
    icon: 'fo-statistics',
    isCustomIcon: true,
    translationsKey: 'base-layout.statistics',
    isExpandable: false,
  },
  {
    role: RoleEnum.Admin,
    link: '/admin/reports',
    icon: 'file_download',
    translationsKey: 'base-layout.reports',
    isExpandable: false,
  },
  {
    role: RoleEnum.Admin,
    link: '/admin/audit-logs',
    icon: 'search',
    translationsKey: 'base-layout.audit-log',
    isExpandable: false,
  },
  {
    role: RoleEnum.Admin,
    link: '/admin/olympus-admin-panel',
    icon: 'manage_history',
    translationsKey: 'base-layout.olympus-admin-panel',
    isExpandable: false,
  },
];

export const OPCO_LINKS: FlexyooNavLinks[] = [
  {
    role: RoleEnum.Opco,
    link: '/opco/clients',
    icon: 'domain',
    translationsKey: 'base-layout.clients',
    isExpandable: false,
  },
  {
    role: RoleEnum.Opco,
    link: '/opco/users',
    icon: 'fo-person',
    isCustomIcon: true,
    translationsKey: 'base-layout.users',
    isExpandable: false,
  },
  {
    role: RoleEnum.Opco,
    link: '/opco/groups',
    icon: 'fo-group',
    isCustomIcon: true,
    translationsKey: 'base-layout.groups',
    isExpandable: false,
  },
];
